import { render } from "./ConsignedUpdate.vue?vue&type=template&id=6db80d67"
import script from "./ConsignedUpdate.vue?vue&type=script&lang=js"
export * from "./ConsignedUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__